import { css } from "@emotion/core";
import {
  UploadTypes,
  color,
  fontTypes,
  fontSizes,
  fontWeight,
} from "../../constants/commons";

export const uploadStyle = (
  uploadType: UploadTypes,
  isMobileView: boolean | 0 | undefined,
  errorWhileUpload: boolean
) => css`
  width: 100%;
  .ant-upload-picture-card-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .preview-image-style {
    border-radius: 50%;
    width: 5.5em;
  }
  .ant-upload.ant-upload-select-picture-card {
    ${uploadType !== UploadTypes.PROFILE_PICTURE &&
    `background: {${isMobileView} ? ${color.white} : ${color.whitishGray}};
    border-radius: 0.25em;
    border: 1px solid ${color.darkRed};
    height: 3.75em;
    border-style: dotted;
    width: 100%`}
  }

  ${errorWhileUpload} && .ant-upload-list {
    display: none;
  }

  .browse-style {
    color: ${color.pink};
  }

  .upload-mobile-icon-width {
    width: 1.1em;
  }

  .red-color-text {
    color: ${color.red} !important;
  }

  .upload-document-style {
    font-family: ${fontTypes.meduim};
    /* Extra small devices (portrait phones, less than 576px) */
    @media (max-width: 575.98px) {
      font-size: ${fontSizes.md};
    }
    font-size: ${fontSizes.sm};
    font-weight: ${fontWeight.medium};
    color: ${color.black};
  }

  .file-upload-color {
    color: ${color.red};
  }

  a {
    color: ${color.black};
    text-decoration: none;
  }

  a:hover,
  a:active,
  a:active:focus,
  a:visited,
  a:focus {
    color: ${color.black};
    text-decoration: none;
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .info-box-icon {
      width: 15%;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .info-box-icon {
      width: 15%;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .info-box-icon {
      width: 10%;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .info-box-icon {
      width: 10%;
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .info-box-icon {
      width: 10%;
    }
  }
`;
